// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu EMI Calculator Styles
   ========================================== */

.emi-calc-wrapper {
  background: transparent;
  width: 100%;
}

.calculator-section {
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: 2.25rem;
  width: 100%;
  max-width: 620px;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  margin: 0 auto;
}

.calc-header {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-glass);
}

.icon-container {
  width: 52px;
  height: 52px;
  border-radius: var(--radius-md);
  background: rgba(245, 158, 11, 0.15);
  border: 1px solid rgba(245, 158, 11, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.calculator-icon {
  font-size: 1.75rem;
  color: #818cf8;
}

.header-text .title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.header-text .description {
  font-size: 0.9rem;
  color: var(--text-muted);
  margin: 0;
}

.inputs {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: #e2e8f0;
}

.value-display {
  font-size: 0.95rem;
  font-weight: 700;
  color: #a5b4fc;
  padding: 0.3rem 0.8rem;
  background: rgba(245, 158, 11, 0.15);
  border: 1px solid rgba(245, 158, 11, 0.25);
  border-radius: var(--radius-sm);
}

.slider {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  accent-color: var(--color-primary);
  outline: none;
  transition: all 0.2s ease;
  cursor: pointer;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--color-primary);
  border: 2px solid #ffffff;
  box-shadow: 0 0 10px rgba(245, 158, 11, 0.6);
  cursor: pointer;
}

.summary {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.summary-header {
  font-size: 1.15rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.5rem;
  text-align: center;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
  padding: 0.4rem 0;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.06);
}

.summary-item:last-child {
  border-bottom: none;
}

.summary-label {
  color: var(--text-muted);
}

.summary-value {
  font-weight: 700;
  color: #ffffff;
}

.summary-value.positive {
  color: var(--color-emerald);
  font-size: 1.1rem;
}

.chart-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-glass);
}

.chart-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffffff;
}

.pie-wrapper {
  width: 220px;
  height: 220px;
}`, "",{"version":3,"sources":["webpack://./src/Components/EmiCalculator.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":["/* ==========================================\n   Kubersetu EMI Calculator Styles\n   ========================================== */\n\n.emi-calc-wrapper {\n  background: transparent;\n  width: 100%;\n}\n\n.calculator-section {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  padding: 2.25rem;\n  width: 100%;\n  max-width: 620px;\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n  margin: 0 auto;\n}\n\n.calc-header {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--border-glass);\n}\n\n.icon-container {\n  width: 52px;\n  height: 52px;\n  border-radius: var(--radius-md);\n  background: rgba(245, 158, 11, 0.15);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.calculator-icon {\n  font-size: 1.75rem;\n  color: #818cf8;\n}\n\n.header-text .title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.header-text .description {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\n.value-display {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #a5b4fc;\n  padding: 0.3rem 0.8rem;\n  background: rgba(245, 158, 11, 0.15);\n  border: 1px solid rgba(245, 158, 11, 0.25);\n  border-radius: var(--radius-sm);\n}\n\n.slider {\n  width: 100%;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  accent-color: var(--color-primary);\n  outline: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--color-primary);\n  border: 2px solid #ffffff;\n  box-shadow: 0 0 10px rgba(245, 158, 11, 0.6);\n  cursor: pointer;\n}\n\n.summary {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.summary-header {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n  text-align: center;\n}\n\n.summary-item {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.95rem;\n  padding: 0.4rem 0;\n  border-bottom: 1px dashed rgba(255, 255, 255, 0.06);\n}\n\n.summary-item:last-child {\n  border-bottom: none;\n}\n\n.summary-label {\n  color: var(--text-muted);\n}\n\n.summary-value {\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.summary-value.positive {\n  color: var(--color-emerald);\n  font-size: 1.1rem;\n}\n\n.chart-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-glass);\n}\n\n.chart-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.pie-wrapper {\n  width: 220px;\n  height: 220px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
